import Core from '@mediaplatform/sportal365-multisport-sdk';
import { IMultisportApi, OddFormat, SportTypes } from '../types';

export default (sdk: Core): IMultisportApi => {
  const validateSport = (sport?: SportTypes | null) => {
    if (sport && !Object.values(SportTypes).includes(sport)) {
      throw new Error(`Invalid sport type: ${sport}. Please pass a valid sport.`);
    }
  };

  const competitions: IMultisportApi['competitions'] = ({ sport, date }: { sport?: SportTypes; date: string }) => {
    const competitions = sdk.competitions();

    if (competitions) {
      competitions.getDate(date);

      if (sport) {
        competitions.getSport(sport);
      }

      return competitions.get();
    }
  };

  const events: IMultisportApi['events'] = ({
    sport,
    date,
    competitionIds,
    nameType,
    dataOddsBettingId,
    dataOddsDisplay,
    dataOddsPreEventOnly,
  }) => {
    const events = sdk.events();

    if (events) {
      events.getDate(date);

      if (sport) {
        events.getSport(sport);
      }

      if (competitionIds) {
        events.getCompetitionIds(competitionIds);
      }

      if (nameType) {
        // any is used here because the SDK expects a specific string type but the models are not exported
        events.withNameType(nameType as any);
      }

      if (dataOddsDisplay && dataOddsBettingId) {
        events.withOdds({
          bettingId: dataOddsBettingId,
          market: '1x2,12',
          preEventOddsOnly: dataOddsPreEventOnly,
          oddFormat: OddFormat.DECIMAL,
        });
      }

      return events.get();
    }
  };

  const competitionEvents: IMultisportApi['competitionEvents'] = ({
    sport,
    date,
    competitionIds,
    nameType,
    limit,
    dataOddsBettingId,
    dataOddsDisplay,
    dataOddsPreEventOnly,
  }) => {
    try {
      validateSport(sport);

      const competitionEvents = sdk.competitionEvents();

      if (competitionEvents) {
        competitionEvents.getDate(date);

        if (sport) {
          competitionEvents.getSport(sport);
        }

        if (competitionIds) {
          competitionEvents.getCompetitionIds(competitionIds);
        }

        if (nameType) {
          competitionEvents.withNameType(nameType as any);
        }

        if (limit) {
          competitionEvents.withLimit(limit);
        }

        if (dataOddsDisplay && dataOddsBettingId) {
          competitionEvents.withOdds({
            bettingId: dataOddsBettingId,
            market: '1x2,12',
            preEventOddsOnly: dataOddsPreEventOnly,
            oddFormat: OddFormat.DECIMAL,
          });
        }

        return competitionEvents.get();
      }
    } catch (error) {
      console.error('Error in fetching competition events:', error);
      return Promise.reject(error);
    }
  };

  return {
    competitions,
    events,
    competitionEvents,
  };
};
